

























import { Vue, Component, Prop, Ref } from 'vue-property-decorator';
import { Image } from 'vant';

Vue.use(Image);
@Component({
  name: 'XcqImage',
  inheritAttrs: false,
  components: {},
})
export default class XcqImage extends Vue {
  @Prop({ default: '' }) src!: string;
  @Prop({ default: 'cover' }) fit!: any;

  @Ref('imageRef') imageRef!: any;

  private hasParentHeight = false;
  private parentResizeObserver: any;
  private defaultImageCover = '';

  get attrs(): any {
    return this.$attrs;
  }

  created() {}

  mounted() {
    this.$nextTick(() => {
      this.syncParentHeight();
    });
  }

  beforeDestroy() {
    if (this.parentResizeObserver) {
      this.parentResizeObserver.disconnect();
    }
  }

  private getImageElement(): HTMLElement | undefined {
    return this.imageRef.$el as HTMLElement | undefined;
  }

  private detectParentHasHeight(parent: HTMLElement): boolean {
    const probe = document.createElement('div');
    probe.style.cssText = [
      'width:0',
      'height:100%',
      'overflow:hidden',
      'padding:0',
      'margin:0',
      'border:0',
      'pointer-events:none',
      'opacity:0',
    ].join(';');

    parent.appendChild(probe);
    const probeHeight = probe.getBoundingClientRect().height;
    parent.removeChild(probe);

    return probeHeight > 0;
  }

  private syncParentHeight(): void {
    const imageElement: any = this.getImageElement();
    const parentElement = imageElement.parentElement;

    this.hasParentHeight = parentElement
      ? this.detectParentHasHeight(parentElement)
      : false;
  }

  handleClick(event: MouseEvent): void {
    this.$emit('click', event);
  }

  handleLoad(event: Event): void {
    this.syncParentHeight();
    this.$emit('load', event);
  }

  handleError(event: Event): void {
    this.syncParentHeight();
    this.$emit('error', event);
  }
}
